import { COLORS } from '@/constants';
import { Box } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.section<{ $bgColor?: keyof typeof COLORS; $overflow?: boolean }>`
  position: relative;
  background: ${(props) => (props.$bgColor ? COLORS[props.$bgColor] : COLORS.white)};
  width: 100%;
  overflow: ${(props) => (props.$overflow ? 'hidden' : 'visible')};
`;

export const Container = styled.div<{ $isRelative?: boolean }>`
  margin: 0 auto;
  max-width: 1212px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  color: ${COLORS['primary/900']};

  @media (max-width: 920px) {
    gap: 18px;
  }
`;

export const ContentCard = styled(Box)<{ $borderless?: boolean }>(({ $borderless }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '22px',
  borderRadius: '10px',
  border: $borderless ? 'none' : `1px solid ${COLORS['neutral/300']}`,
  padding: $borderless ? '0' : '20px 24px',
}));

export const LoaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 90px 0;
`;


export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const DataRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px 18px;
  flex-wrap: wrap;
`;

export const MainColsWrap = styled.div`
  display: flex;
  gap: 23px;
  @media (max-width: 920px) {
    flex-direction: column;
    gap: 18px;
  }
`;

export const MainColContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 38px;

  @media (max-width: 920px) {
    gap: 18px;
  }
`;